import React from 'react';
import { Grid, Paper, Box, Typography } from '@mui/material';

export default function AgentCommissionSummary({ summary = {} }) {
  const cards = [
    { id: 'today', title: "Today's Earnings", value: summary.today ?? '₹0' },
    { id: 'week', title: 'This Week', value: summary.week ?? '₹0' },
    { id: 'month', title: 'This Month', value: summary.month ?? '₹0' },
  ];

  return (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      {cards.map((c) => (
        <Grid item xs={12} md={4} key={c.id}>
          <Paper sx={{ p: 2, borderRadius: 2, boxShadow: '0 6px 18px rgba(15,23,42,0.06)' }}>
            <Typography variant="subtitle2" color="text.secondary">{c.title}</Typography>
            <Typography variant="h5" fontWeight={700}>{c.value}</Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}
